import { getAddress, isAddress, type Address } from 'viem';

const HEX40 = /^0x[0-9a-fA-F]{40}$/;

/**
 * Returns the EIP-55 checksummed address, or null if `v` is not a valid address.
 * All-lowercase and all-uppercase hex are accepted; mixed case must carry a correct checksum.
 */
export function normalizeAddress(v: unknown): Address | null {
  if (typeof v !== 'string') return null;
  const s = v.trim();
  if (!HEX40.test(s)) return null;
  const body = s.slice(2);
  if (body !== body.toUpperCase() && !isAddress(s)) return null;
  return getAddress(s.toLowerCase());
}

/** 0xd095…ec43 */
export function shortAddress(a: string): string {
  return a.length > 12 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a;
}
